'use strict';
/*
* Special Page Modal Window
* @package krobot
* @deps jquery
*/
const $ = jQuery;
let spHeaderHeight;
let translate;

//toggle drop element
$( '.js-sp-drop a[href^="#"]' ).on( 'click keypress', function() {
	const targetDropElement = $( this ).attr( 'href' );
	const targetDropObj = $( targetDropElement );
	const headerHeight = $( '.site-header' ).outerHeight();
	if ( window.matchMedia( '(min-width: 980px)' ).matches ) {
		spHeaderHeight = $( '.js-sp-header-pc' ).outerHeight();
	} else {
		spHeaderHeight = $( '.js-sp-header-sp' ).outerHeight();
	}
	if ( targetDropObj.hasClass( 'expanded' ) ) {
		targetDropObj.css( 'transform', 'translateY(-100%)' );
		targetDropObj.removeClass( 'expanded' );
		$( this ).removeClass( 'opened' );
	} else {
		targetDropObj.addClass( 'expanded' );
		$( this ).addClass( 'opened' );
		if ( headerHeight ) {
			translate = 'translateY(' + headerHeight + 'px)';
		} else if ( spHeaderHeight ) {
			translate = 'translateY(' + spHeaderHeight + 'px)';
		} else {
			translate = 'translateY(0)';
		}
		targetDropObj.css( 'transform', translate );
	}
	return false;
} );

// window resize rest
$( window ).on( 'load resize', function() {
	resetDropElements();
	return false;
} );

// close drop button
$( '.js-sp-drop-close a' ).on( 'click keypress', function() {
	resetDropElements();
	return false;
} );

function resetDropElements() {
	$( '.sp-drop' ).removeClass( 'expanded' );
	$( '.sp-drop' ).css( 'transform', 'translateY(-100%)' );
	$( '.js-sp-drop a[href^="#"]' ).removeClass( 'opened' );
}
